import React from "react";
import { TypographyProps } from "./types";
import { StyledTypography } from "./styles";
import ThemeColors from "../../themes/colors";
import ThemeSize from "../../themes/fontSize";

const Typography: React.FC<TypographyProps> = ({
  text,
  color = ThemeColors.Black900,
  size = ThemeSize.medium,
  weight = 400,
  fontStyle = "normal",
  textAlign = "justify",
}): JSX.Element => {
  return (
    <StyledTypography
      color={color as keyof typeof ThemeColors}
      size={size as keyof typeof ThemeSize}
      weight={weight}
      fontStyle={fontStyle}
      textAlign={textAlign}
    >
      {text}
    </StyledTypography>
  );
};

export default Typography;
